'use client'

import Slider from 'react-slick'

import { styled } from '@mui/material'

import 'slick-carousel/slick/slick.css'

export const SliderWrapper = styled('div')(({ theme }) => ({
  height: '100%',
  padding: 32,
  width: '100%',

  '& .slick-arrow': {
    height: 34,
    width: 50,
    padding: 0,
    display: 'inline-flex!important',
    borderRadius: '16px',
    position: 'absolute',
    top: '50%',
    zIndex: 10,
    background: theme.palette.background.carouselButton,
  },
  '&:hover': {
    '& .slick-arrow': {
      background: theme.palette.background.carouselButton,
    },
  },
  '& .imageNavigation .slick-arrow': {
    background: 'transparent',
  },
  '& .slick-prev': { left: 0, transform: 'translate(-100%,-50%)' },
  '& .slick-next': { right: 0, transform: 'translate(100%,-50%)' },
  '& .imageNavigation .slick-prev': { left: '50px' },
  '& .imageNavigation .slick-next': { right: '50px' },
  [theme.breakpoints.down('sm')]: {
    '& .slick-prev': { transform: 'translate(-16px,-50%)', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 },
    '& .slick-next': { transform: 'translate(16px,-50%)', borderTopRightRadius: 0, borderBottomRightRadius: 0 },
  },
  '& .slick-arrow.slick-disabled': { display: 'none!important' },
}))

export const SlideWrapper = styled('div')({
  position: 'relative',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
})

export const StyledSlider = styled(Slider)(({ theme }) => ({
  '&.slick-slider': {
    height: '100%',
  },
  '& .slick-track': {
    display: 'flex',
  },
  '& .slick-list': {
    display: 'flex',
    height: 'inherit !important',
  },
  '& .slick-slide': {
    position: 'relative',
    height: 'inherit',
    float: 'left',
    '& > div': {
      height: '100%',
      cursor: 'pointer',
      position: 'relative',
      '& > div': {
        height: '100%',
      },
    },
  },
  '& .slick-dots': {
    position: 'absolute',
    display: 'inline-flex !important',
    justifyContent: 'center',
    width: '100%',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    textAlign: 'center',
    bottom: '-24px',
    '& li': {
      position: 'relative',
      display: 'inline-block',
      width: 20,
      height: 20,
      margin: '0 5px',
      padding: 0,
      '& button': {
        fontSize: 0,
        lineHeight: 0,
        display: 'block',
        width: 20,
        height: 20,
        padding: 5,
        cursor: 'pointer',
        color: 'transparent',
        border: 0,
        outline: 'none',
        background: 'transparent',
        '&::before': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 12,
          height: 12,
          backgroundColor: theme.palette.background.light,
          borderRadius: '100%',
          border: '0.5px solid #787575',
          content: "''",
          transition: 'opacity 0.3s ease-in-out',
          transform: 'translate(-50%,-50%)',
        },
        '&:hover': {
          '&::before': {
            backgroundColor: theme.palette.background.pale,
          },
        },
      },

      '&.slick-active button::before': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  },
  '& .slick-dots.heroBanner': {
    bottom: '16px',
    width: 'fit-content',
    left: '50%',
    transform: 'translate(-50%, 0)',
    [theme.breakpoints.down('md')]: { bottom: '20px' },
  },

  '& .slick-dots.navImages': {
    position: 'static',
    paddingTop: '60px',

    '& li': {
      position: 'relative',
      display: 'inline-block',
      width: 80,
      height: 80,
      margin: '0 5px',
      padding: 0,
    },
    '& li img: hover ': {
      cursor: 'pointer',
    },
    '& li.slick-active img': {
      opacity: 0.4,
      '&: hover': {
        cursor: 'auto',
      },
    },
  },
}))
